import React from 'react';

import {
  Check,
  Input,
  Label,
  Contain,
  RadioDisplay
} from './Styled';

import ErrorText from '../InputErrorText';

const CheckBox = ({ name, label, value, onClick, errorText }) => (
  <React.Fragment>
    <Contain
      onClick={() => onClick(name, !value)}
    >
      <Input
        readOnly
        name={name}
        type='checkbox'
        checked={value}
      />

      <RadioDisplay
        checked={value}
        error={!!errorText}
      >
        <Check checked={value} />
      </RadioDisplay>

      <Label htmlFor={name}>
        {label}
      </Label>
    </Contain>

    <ErrorText errorText={errorText} />
  </React.Fragment>
);

CheckBox.defaultProps = {
  value: false,
  onClick: () => false
};

export default CheckBox;
